import { render } from "./FlowsTab.vue?vue&type=template&id=3444951f&scoped=true"
import script from "./FlowsTab.vue?vue&type=script&lang=js"
export * from "./FlowsTab.vue?vue&type=script&lang=js"

import "./FlowsTab.vue?vue&type=style&index=0&id=3444951f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444951f"]])

export default __exports__